import React, { useEffect, useState } from "react";
import { useDashboardHook } from "../../hooks/useDashboardHooks";
import Axios from "axios";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { getCenter } from "../../util";
import { VisualCrossKey } from "src/config/secret";
import { Spinner } from "reactstrap";

const VisualCrossingURL =
  "https://weather.visualcrossing.com/VisualCrossingWebServices/rest/services/timeline";

const PrecipitationChart = () => {
  const { chosenField } = useDashboardHook();
  const [data, setData] = useState<{ datetime: string; precip: number }[]>();
  const [isFetching, setFetching] = useState(false)

  useEffect(() => {
    if (!chosenField.coordinates) return;
    const source = Axios.CancelToken.source();
    const fetchData = async () => {
      try {
        setFetching(true);

        const center = getCenter(chosenField.coordinates);
        const endDate = new Date();
        endDate.setDate(endDate.getDate() + 2);
        const startDate = new Date(endDate);
        startDate.setDate(startDate.getDate() - 14);

        const [start, end] = [startDate, endDate].map(
          (date) => date.toISOString().split("T")[0]
        );

        const { data } = await Axios.get(
          `${VisualCrossingURL}/${center.lat},${center.lng}/${start}/${end}`,
          {
            params: {
              unitGroup: "uk",
              key: VisualCrossKey,
              include: "days",
              elements: "precip,datetime",
            },
            cancelToken: source.token,
          }
        );

        setData(data.days);
        setFetching(false);

      } catch (err) {
        if (!Axios.isCancel(err)) {
          console.error(err);
          setFetching(false);
        }
      }
    };

    fetchData();

    return () => {
      setFetching(false);
      source.cancel();
    }
  }, [chosenField.coordinates]);

  return (
    <ResponsiveContainer height={300} width="100%">
      {isFetching ?
        <div className="d-flex flex-column h-100 justify-content-center ">
          <Spinner className="mx-auto d-block" />
        </div>
        :
        <BarChart
          data={data}
          margin={{ top: 50, right: 30, bottom: 5, left: 30 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="datetime" />
          <YAxis yAxisId="left" orientation="left" stroke="#5c5c5c" unit="mm" />
          <Tooltip />
          <Bar yAxisId="left" dataKey="precip" fill="#8884d8" />
        </BarChart>
      }
    </ResponsiveContainer >
  );
};

export default PrecipitationChart;
